export default __webpack_public_path__ + "static/media/icons8-subscribe.9a9b67ac.gif";